import State from "models/state"
import {connect} from "react-redux"

export const mapStateToProps = (state: State) => {
    const {template} = state

    return {
        templating: template,
    }
}

export default connect(mapStateToProps)
